export default __webpack_public_path__ + "static/media/MAQUINADOINDPORTARROLLOS.c47ef7bb.webp";